/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a2ca9a3d5107d7ac162a2a33430a5c3>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/incident';
import NewObjectComponent from '@atlaskit/object/incident';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/incident/16';

/**
 * __16px `incident` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Incident16Icon = function Incident16Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  // Feature flag to migrate to new object package
  if (fg('platform_dst_icon_object_to_object')) {
    // Map props based on size: 16px -> object (medium), 24px -> tile (small)
    return /*#__PURE__*/React.createElement(NewObjectComponent, {
      label: label,
      testId: testId,
      size: "medium"
    });
  }
  return /*#__PURE__*/React.createElement(IconTile, {
    icon: NewIcon,
    appearance: "redBold",
    size: "16",
    label: label,
    testId: testId,
    LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    })
  });
};
Incident16Icon.displayName = 'Incident16Icon';
export default Incident16Icon;